import React from 'react'
import Styled from 'styled-components'

import Icon from 'components/Icon'

const Container = Styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.gray.shade100};
  cursor: pointer;
  transition: 300ms;

  &:hover {
    color: ${props => props.theme.colors.gray.shade200};
  }

  & > i {
    font-size: 2rem;
  }
`

export default props => (
  <Container>
    <Icon
      liga="close"
      onClick={props.onClose}
    />
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/SidebarClose/index.js